class BuyNow {
  #inFlightForms = new WeakSet();

  constructor() {
    this._bindEvents();
  }

  _bindEvents() {
    document.addEventListener('click', (event) => this._onClick(event), true);
    document.addEventListener('submit', (event) => this._onSubmit(event), true);
  }

  _onClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-buy-now]');
    if (!(button instanceof HTMLButtonElement)) return;

    const form = button.form;
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();
    this.buyNow(form);
  }

  _onSubmit(event) {
    const form = this.getFormFromEvent(event.target);
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();
    this.buyNow(form);
  }

  getFormFromEvent(target) {
    if (!(target instanceof Element)) return null;

    const form = target.closest('form');
    if (!(form instanceof HTMLFormElement)) return null;

    const button = form.querySelector('[data-buy-now]');
    if (!button) return null;

    return form;
  }

  setMessage(form, text, isError) {
    const message = form.querySelector('[data-buy-now-message]');
    if (!message) return;

    if (!text) {
      message.textContent = '';
      message.setAttribute('hidden', 'hidden');
      message.classList.remove('is-error');
      return;
    }

    message.textContent = text;
    message.removeAttribute('hidden');
    message.classList.toggle('is-error', Boolean(isError));
  }

  setButtonState(button, isLoading) {
    if (!button) return;

    const defaultLabel =
      button.getAttribute('data-label-default') || button.textContent || '';
    const loadingLabel =
      button.getAttribute('data-label-loading') || defaultLabel;

    if (isLoading) {
      button.setAttribute('disabled', '');
      button.setAttribute('aria-disabled', 'true');
      button.textContent = loadingLabel;
      return;
    }

    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.textContent = defaultLabel;
  }

  async buyNow(form) {
    if (this.#inFlightForms.has(form)) return;

    const button = form.querySelector('[data-buy-now]');
    if (!(button instanceof HTMLButtonElement)) return;

    const variantIdInput = form.querySelector("[name='id']");
    if (
      !(variantIdInput instanceof HTMLInputElement) ||
      !variantIdInput.value
    ) {
      this.setMessage(form, 'Please select a valid product option.', true);
      return;
    }

    let quantity = 1;
    const quantityInput = form.querySelector("[name='quantity']");
    if (quantityInput instanceof HTMLInputElement && quantityInput.value) {
      const parsed = parseInt(quantityInput.value, 10);
      if (!Number.isNaN(parsed) && parsed > 0) {
        quantity = parsed;
      }
    }

    this.#inFlightForms.add(form);
    this.setMessage(form, '');
    this.setButtonState(button, true);

    const formData = {
      items: [
        {
          id: variantIdInput.value,
          quantity: quantity,
        },
      ],
    };

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error('Network response was not ok');

      // Click the hidden [data-buy-now-checkout] button that lives inside a
      // real {% form 'cart', cart %} in the snippet. This lets checkout-override
      // apps (e.g. COD King) intercept the submit event as they do for the
      // regular cart checkout button. Falls back to direct navigation if the
      // element is not found (e.g. rendered outside a product page).
      const checkoutTrigger =
        button
          .closest('.buy-now-button-wrapper, section, [id]')
          ?.querySelector('[data-buy-now-checkout]') ??
        document.querySelector('[data-buy-now-checkout]');
      if (checkoutTrigger instanceof HTMLButtonElement) {
        checkoutTrigger.click();
      } else {
        window.location.href = '/checkout';
      }
    } catch (error) {
      const fallback =
        button.getAttribute('data-message-error') ||
        'Unable to process purchase right now.';
      const msg =
        error instanceof Error && error.message ? error.message : fallback;
      this.setMessage(form, msg, true);
    } finally {
      this.setButtonState(button, false);
      this.#inFlightForms.delete(form);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BuyNow();
});

export default BuyNow;
